import list from './list'
export { teamListQuery } from './list'

export default { list }
